import images from "./images";

const gallery = [
  {
    id: 1,
    image: images.gallery1,
    title: "Living Room Interior",
    category: "Interiors",
  },
  {
    id: 2,
    image: images.gallery2,
    title: "Courtyard Landscape",
    category: "Landscape",
  },
  {
    id: 3,
    image: images.gallery3,
    title: "Office Renovation",
    category: "Renovation",
  },
  {
    id: 4,
    image: images.gallery4,
    title: "Bedroom Interior",
    category: "Interiors",
  },
  {
    id: 5,
    image: images.gallery5,
    title: "Botanical Garden",
    category: "Landscape",
  },
  {
    id: 6,
    image: images.gallery6,
    title: "Residential Design",
    category: "Renovation",
  },
];

export default gallery;